module.exports = __webpack_public_path__ + "img/img-chart-01.e258c0a9.png";